import type { AxiosInstance, AxiosRequestConfig } from 'axios';

let _client: AxiosInstance;

/**
 * Inject the configured Axios instance used by all generated query hooks.
 * Must be called once at app startup, before React renders.
 */
export function setAxiosInstance(instance: AxiosInstance): void {
  _client = instance;
}

/**
 * Orval custom mutator. All generated query hooks call this function.
 */
export const customMutator = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const { data } = await _client({ ...config, ...options });
  return data;
};
